export const handleClear = (inputStates) => {
  inputStates.forEach((set) => set(""));
};
